import { TFunction } from "react-i18next";
import * as yup from "yup";

import { Account } from "../../../../../../models/account";

export const handleValidate = (
  translate: TFunction<"translate", undefined>,
  account: Account,
  callback: (error: yup.ValidationError[]) => void
) => {
  try {
    const detailsSchema = yup.object().shape({
      name: yup.string().required(translate("thisFieldIsRequired")),
      status: yup.string().required(translate("thisFieldIsRequired")),
    });

    detailsSchema.validateSync(
      {
        name: account?.name,
        status: account?.status,
      },
      { abortEarly: false }
    );
    callback([]);

    return true;
  } catch (err) {
    if (err instanceof yup.ValidationError) {
      callback(err?.inner);
    }

    return false;
  }
};
